export const educationData = [
    {
        id: 1,
        institution: 'Chengdu Shishi High School',
        course: 'High School Education',
        startYear: '2018',
        endYear: '2021'
    },
    {
        id: 2,
        institution: 'University of Washington',
        course: 'Bachelor of Science in Informatics',
        startYear: '2021',
        endYear: '2025'
    },
]